{
	"ariaDeleteAllPointColorSwatches": "Delete All Point Color Swatches",
	"ariaDeletePointColorSwatch": "Delete Point Color Swatch",
	"ariaPointColorSelectorMenu": "Point Color Selector Menu",
	"deleteAllSwatches": "Delete All Swatches",
	"deleteSwatch": "Delete Swatch",
	"hueRange": "Hue Range",
	"luminanceRange": "Luminance Range",
	"panelPointColor": "Point Color",
	"saturationRange": "Saturation Range",
	"sliderHueShift": "Hue Shift",
	"sliderLumShift": "Lum. Shift",
	"sliderRange": "Range",
	"sliderSatShift": "Sat. Shift",
	"toastClickBrighterArea": "Please click on a brighter area",
	"toastMaxColorsReached": "Maximum 10 colors can be added.",
	"toastSelectMoreSaturated": "Please select a more saturated color"
}
